<template>
  <div>
    <Login />
  </div>
</template>

<script>
import Login from "@/components/Login.vue";

export default {
  name: "login-page",
  components: {
    Login
  }
};
</script>

<style>
body {
  background-color: #313d55;
}
</style>
